import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {encodingClothsImages} from '../cloths-mockup';
import {encodingSymbolsImages} from '../symbols-mockup';

@Component({
  selector: 'app-build-message',
  templateUrl: './build-message.component.html',
  styleUrls: ['./build-message.component.css']
})
export class BuildMessageComponent extends GeneralExerciseComponent {

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
  }

  checkSolution() {
    if (this.solved) {
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  setSolved(solved: boolean) {
    this.solved = solved;
    this.checkSolution();
  }

  generateNextExercise() {
    this.counter ++;
    this.initValues();
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }
}
